import Box from "@mui/material/Box"
import IconButton from "@mui/material/IconButton"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography"
import { EditOutlined } from "@mui-symbols-material/w300"
import { type FC } from "react"

import type { ProductQualityInstructions } from "../../types"
import { renderCheckMarkIcon } from "../../utils"

import { PermissionActionType } from "@/constants/permissions"
import { usePermissionManager } from "@/hooks/usePermissionManager"

interface AssociatedTestTemplatePreTestNoteSectionProps {
  productQualityInstructions: ProductQualityInstructions
  onEdit: () => void
}

export const AssociatedTestTemplatePreTestNoteSection: FC<AssociatedTestTemplatePreTestNoteSectionProps> = ({
  productQualityInstructions,
  onEdit,
}) => {
  const { hasPermissions } = usePermissionManager()
  const isPrintExpirationToAkrochemCoa = Boolean(productQualityInstructions.printExpirationToAkrochemCoa)
  const isPrintMfgDatesToAkrochemCoa = Boolean(productQualityInstructions.printMfgDatesToAkrochemCoa)
  const isPrintPreTestNotesToAkrochemCoa = Boolean(productQualityInstructions.printPreTestNotesToAkrochemCoa)

  return (
    <Paper
      variant='outlined'
      elevation={0}
      className='flex flex-col gap-y-6 border-gray-300 p-6'
      data-testid='pre-test-notes-section'
    >
      <Box className='flex items-center justify-between gap-4'>
        <Typography variant='subtitle1' component='h3' className='text-ml text-gray-900'>
          Pre Test Note
        </Typography>
        {hasPermissions([PermissionActionType.TEST_TEMPLATE_MAINTENANCE]) && (
          <IconButton onClick={onEdit} data-testid='edit-pre-test-notes-button'>
            <EditOutlined color='primary' />
          </IconButton>
        )}
      </Box>
      <Box className='flex items-start justify-start gap-6'>
        <Typography className='font-normal text-gray-900' variant='body2'>
          <Box component='span' data-testid='print-expiration-icon'>
            {renderCheckMarkIcon(isPrintExpirationToAkrochemCoa)}
          </Box>{" "}
          Print Expiration to Akrochem COA
        </Typography>
        <Typography className='font-normal text-gray-900' variant='body2'>
          <Box component='span' data-testid='print-mfg-dates-icon'>
            {renderCheckMarkIcon(isPrintMfgDatesToAkrochemCoa)}
          </Box>{" "}
          Print Mfg.Dates to Akrochem COA
        </Typography>
        <Typography className='font-normal text-gray-900' variant='body2'>
          <Box component='span' data-testid='print-pre-test-notes-icon'>
            {renderCheckMarkIcon(isPrintPreTestNotesToAkrochemCoa)}
          </Box>{" "}
          Print Pre Test Notes to Akrochem COA
        </Typography>
      </Box>
      {productQualityInstructions?.preTestNotes && (
        <Typography className='font-normal text-gray-900' variant='body2' data-testid='pre-test-notes'>
          {productQualityInstructions.preTestNotes}
        </Typography>
      )}
    </Paper>
  )
}
